import { render, staticRenderFns } from "./SoundSettingsPopup.vue?vue&type=template&id=476c6f20&scoped=true&"
import script from "./SoundSettingsPopup.vue?vue&type=script&lang=js&"
export * from "./SoundSettingsPopup.vue?vue&type=script&lang=js&"
import style0 from "./SoundSettingsPopup.vue?vue&type=style&index=0&id=476c6f20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476c6f20",
  null
  
)

export default component.exports